import React, { useState, useEffect, useRef, useContext } from 'react';
import classNames from 'classnames';
import { Navigate, Outlet, Route, Routes, useLocation } from 'react-router-dom';
import { helpAuth } from './helpers/helpAuth';
import AuthContext from "./context/AuthContext";
import { CSSTransition } from 'react-transition-group';

import { AppTopbar } from './AppTopbar';
import { AppFooter } from './AppFooter';
import { AppMenu } from './AppMenu';
import { AppConfig } from './AppConfig';

import Signoff from './pages/access/Signoff';
import Filtro from './pages/registro/Filtro';
import Pendientes from './pages/espera/Pendientes';
import Uniforme from './pages/entrega/Uniforme';
import Multientrega from './pages/entrega/Multientrega';
import MultientregaScanner from './pages/entrega/MultientregaScanner';
import ReporteGeneral from './pages/reportes/ReporteGeneral';
import Resumen from './pages/entrega/Resumen';
import FiltroValidacion from './pages/validacion/Filtro';
import Scanner from './pages/entrega/Scanner';

//Reportes
import Dashboard from './pages/reportes/Dashboard';
import ReporteCorteAdministrador from './pages/reportes/ReporteCorteAdministrador';
import ReporteCorteTienda from './pages/reportes/ReporteCorteTienda';
import ReporteNivelMunicipioPdf from './pages/reportes/ReporteNivelMunicipioPdf';
import ReporteMaquila from './pages/reportes/ReporteMaquila';
import ReporteExistenciaInventario from './pages/reportes/ReporteExistenciaInventario';
import ReporteEvidencias from './pages/reportes/ReporteEvidencias';


import ButtonDemo from './components/ButtonDemo';
import ChartDemo from './components/ChartDemo';
import Documentation from './components/Documentation';
import FileDemo from './components/FileDemo';
import FloatLabelDemo from './components/FloatLabelDemo';
import FormLayoutDemo from './components/FormLayoutDemo';
import InputDemo from './components/InputDemo';
import ListDemo from './components/ListDemo';
import MenuDemo from './components/MenuDemo';
import MessagesDemo from './components/MessagesDemo';
import MiscDemo from './components/MiscDemo';
import OverlayDemo from './components/OverlayDemo';
import PanelDemo from './components/PanelDemo';
import TableDemo from './components/TableDemo';
import TreeDemo from './components/TreeDemo';
import InvalidStateDemo from './components/InvalidStateDemo';
import BlocksDemo from './components/BlocksDemo';
import IconsDemo from './components/IconsDemo';

import Crud from './pages/examples/Crud';
import EmptyPage from './pages/examples/EmptyPage';
import ExamplePage from './pages/examples/ExamplePage';
import TimelineDemo from './pages/examples/TimelineDemo';

//import Dashboard from './pages/access/Dashboard';
import Home from './pages/access/Home';
import Login from './pages/access/Login';
import RestorePassword from './pages/access/RestorePassword';
import ExternalRegistration from './pages/access/ExternalRegistration';
import Demand from './pages/demand/registration/Demand';
import DemandList from './pages/demand/registration/DemandList';
import ListaUsuarios from './pages/usuarios/index';
import CreateUser from './pages/usuarios/create';
import ListaTiendas from './pages/tiendas/index';
import CreateTienda from './pages/tiendas/create';
import CambioScanner from './pages/cambios/CambioScanner';


import DemandListAssignment from './pages/demand/assignment/DemandListAssignment';
import DemandListValidation from './pages/demand/validations/DemandListValidation';
import ValidationDocuments from './pages/demand/ValidationDocuments';
import Profile from './pages/access/Profile';

import Error044 from './pages/errors/Error044';
import VerificationUser from './pages/access/VerificationUser';
import VerificationCedula from './pages/demand/VerificationCedula';
import NewPassword from './pages/access/NewPassword';
import Users from './pages/admin/UsersAdmin';
import EmailConfirmacion from './pages/access/EmailConfirmacion';
import DocumentValidationProcess from './pages/demand/DocumentValidationProcess';
import DemandListRegistry from './pages/demand/close/DemandListRegistry';
import DemandListReassignment from './pages/demand/assignment/DemandListReassignment';

import RecordAssignment from './pages/demand/assignment/RecordAssignment';
import RecordValidation from './pages/demand/validations/RecordValidation';
import SolicitudCedula from './pages/demand/close/SolicitudCedula';

/*Almacen*/
import AltaTablets from './pages/almacen/AltaTablets';
import SalidaTablets from './pages/almacen/SalidaTablets';

/*Director*/
import DashboardDirector from './pages/director/DashboardDirector';
import PendientesTablets from './pages/espera/PendientesTablets';
import ResumenTabletas from './pages/entrega/ResumenTabletas';

import ReCaptcha from './pages/examples/ReCaptcha';
import Example from './pages/examples/Example';

import PrimeReact from 'primereact/api';
import { Tooltip } from 'primereact/tooltip';

import 'primereact/resources/primereact.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import 'prismjs/themes/prism-coy.css';
import './assets/demo/flags/flags.css';
import './assets/demo/Demos.scss';
import './assets/layout/layout.scss';
import './App.scss';
import MultientregaTablets from './pages/entrega/MultientregaTablets';
import FiltroAlumno from './pages/registro/FiltroAlumno';
import ImprentaVales from './pages/vales/ImprentaVales';
import ImprentaNominas from './pages/vales/imprentaNominas';
import FiltroCT from './pages/registro/FiltroCT';
import Archivo from './pages/archivos/Archivos';
import CargaArchivos from './pages/archivos/CargaArchivos';
import DashboardMaquila from './pages/maquila/Dashboard';
import ListaCiclos from './pages/ciclos';
import CreateCiclo from './pages/ciclos/create';
// import EntregaPersonal from './pages/entrega/EntregaPersonal';

//import '../src/pages/access/css.css';


const ProtectedRoute = ({
    isAllowed,
    redirectPath = '/login',
    children,
}) => {
    let a = helpAuth();
    if (!a.auth) {
        console.log("redirectPath: " + redirectPath);
        return <Navigate to={redirectPath} replace />;
    }

    return children ? children : <Outlet />;
};

const App = () => {

    const { handleAuth, verifyExp } = useContext(AuthContext);

    const [layoutMode, setLayoutMode] = useState('static');// menu, 
    //const [layoutMode, setLayoutMode] = useState('overlay');

    const [layoutColorMode, setLayoutColorMode] = useState('light')
    const [inputStyle, setInputStyle] = useState('outlined');
    const [ripple, setRipple] = useState(true);
    const [staticMenuInactive, setStaticMenuInactive] = useState(true);// activa el menu por default
    const [overlayMenuActive, setOverlayMenuActive] = useState(false);
    const [mobileMenuActive, setMobileMenuActive] = useState(false);
    const [mobileTopbarMenuActive, setMobileTopbarMenuActive] = useState(false);
    const copyTooltipRef = useRef();
    const location = useLocation();

    const [auth, setAuth] = useState(true);

    PrimeReact.ripple = true;

    let menuClick = false;
    let mobileTopbarMenuClick = false;

    useEffect(() => {
        let a = helpAuth();
        setAuth(a.auth);

        if (a.perfil === 5) {
            setStaticMenuInactive(true);
        }

    }, [handleAuth]);

    useEffect(() => {
        if (mobileMenuActive) {
            addClass(document.body, "body-overflow-hidden");
        } else {
            removeClass(document.body, "body-overflow-hidden");
        }
    }, [mobileMenuActive]);

    useEffect(() => {
        verifyExp();
        copyTooltipRef && copyTooltipRef.current && copyTooltipRef.current.updateTargetEvents();
    }, [location]);

    const onInputStyleChange = (inputStyle) => {
        setInputStyle(inputStyle);
    }

    const onRipple = (e) => {
        PrimeReact.ripple = e.value;
        setRipple(e.value)
    }

    const onLayoutModeChange = (mode) => {
        setLayoutMode(mode)
    }

    const onColorModeChange = (mode) => {
        setLayoutColorMode(mode)
    }

    const onWrapperClick = (event) => {
        if (!menuClick) {
            setOverlayMenuActive(false);
            setMobileMenuActive(false);
        }

        if (!mobileTopbarMenuClick) {
            setMobileTopbarMenuActive(false);
        }

        mobileTopbarMenuClick = false;
        menuClick = false;
    }

    const onToggleMenuClick = (event) => {
        menuClick = true;

        if (isDesktop()) {
            if (layoutMode === 'overlay') {
                if (mobileMenuActive === true) {
                    setOverlayMenuActive(true);
                }

                setOverlayMenuActive((prevState) => !prevState);
                setMobileMenuActive(false);
            }
            else if (layoutMode === 'static') {
                setStaticMenuInactive((prevState) => !prevState);
            }
        }
        else {
            setMobileMenuActive((prevState) => !prevState);
        }

        event.preventDefault();
    }

    const onSidebarClick = () => {
        menuClick = true;
    }

    const onMobileTopbarMenuClick = (event) => {
        mobileTopbarMenuClick = true;

        setMobileTopbarMenuActive((prevState) => !prevState);
        event.preventDefault();
    }

    const onMobileSubTopbarMenuClick = (event) => {
        mobileTopbarMenuClick = true;

        event.preventDefault();
    }

    const onMobileSignOffClick = (event) => {
        //localStorage.clear();

        //return <Redirect to="/login" />

        event.preventDefault();
    }

    const onMenuItemClick = (event) => {
        if (!event.item.items) {
            setOverlayMenuActive(false);
            setMobileMenuActive(false);
        }
    }

    const isDesktop = () => {
        return window.innerWidth >= 992;
    }

    const menu = [
        {
            label: 'FILTROS',
            items: [
                { label: 'ESCUELA', icon: 'pi pi-fw pi-home', to: '/home' },
                { label: 'NIVEL', icon: 'pi pi-fw pi-flag', to: '/dashboard' },
                { label: 'GRADO', icon: 'pi pi-fw pi-tag', to: '/dashboard' },
                { label: 'ZONA ESCOLAR', icon: 'pi pi-fw pi-map', to: '/dashboard' },
                { label: 'SECTOR', icon: 'pi pi-fw pi-compass', to: '/dashboard' },
                { label: 'DELEGACIÓN REGIONAL', icon: 'pi pi-fw pi-map-marker', to: '/dashboard' },
                { label: 'MUNICIPIO', icon: 'pi pi-fw pi-globe', to: '/dashboard' },
                { label: 'FECHA', icon: 'pi pi-fw pi-calendar', to: '/dashboard' }
            ]
        }
    ];

    const addClass = (element, className) => {
        if (element.classList)
            element.classList.add(className);
        else
            element.className += ' ' + className;
    }

    const removeClass = (element, className) => {
        if (element.classList)
            element.classList.remove(className);
        else
            element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }

    const wrapperClass = classNames('layout-wrapper', {
        'layout-overlay': layoutMode === 'overlay',
        'layout-static': layoutMode === 'static',
        'layout-static-sidebar-inactive': staticMenuInactive && layoutMode === 'static',
        'layout-overlay-sidebar-active': overlayMenuActive && layoutMode === 'overlay',
        'layout-mobile-sidebar-active': mobileMenuActive,
        'p-input-filled': inputStyle === 'filled',
        'p-ripple-disabled': ripple === false,
        'layout-theme-light': layoutColorMode === 'light'
    });

    return (
        <div className={wrapperClass} onClick={onWrapperClick}>
            <Tooltip ref={copyTooltipRef} target=".block-action-copy" position="bottom" content="Copied to clipboard" event="focus" />

            <AppTopbar onToggleMenuClick={onToggleMenuClick}
                layoutColorMode={layoutColorMode}
                mobileTopbarMenuActive={mobileTopbarMenuActive}
                onMobileTopbarMenuClick={onMobileTopbarMenuClick}
                onMobileSubTopbarMenuClick={onMobileSubTopbarMenuClick}
                onMobileSignOffClick={onMobileSignOffClick} />

            <div className="layout-sidebar" onClick={onSidebarClick}>
                <AppMenu model={menu} onMenuItemClick={onMenuItemClick} layoutColorMode={layoutColorMode} />
            </div>

            <div className="layout-main-container">
                <div className="layout-main">


                    <Routes>
                        <Route path="/" element={<Login />} />
                        <Route path="/home" element={<Home />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/recuperar-contrasenia" element={<RestorePassword />} />
                        <Route path="/registro" element={<ExternalRegistration />} />
                        <Route path="/verificacion/:q" element={<VerificationUser />} />
                        <Route path="/qr/:q" element={<VerificationCedula />} />
                        <Route path="/nueva-contrasenia/:q" element={<NewPassword />} />
                        <Route path="/correo-confirmacion" element={<EmailConfirmacion />} />


                        <Route path="/Signoff" role="CREAR_SOLICITUD" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <Signoff />
                            </ProtectedRoute>
                        } />

                        <Route path="/filtro/:q" role="CREAR_SOLICITUD" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <Filtro />
                            </ProtectedRoute>
                        } />

                        <Route path="/filtro-ct" role="CREAR_SOLICITUD" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <FiltroCT />
                            </ProtectedRoute>
                        } />

                        <Route path="/filtro-alumno/:q" role="CREAR_SOLICITUD" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <FiltroAlumno />
                            </ProtectedRoute>
                        } />

                        <Route path="/pendientes" role="CREAR_SOLICITUD" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <Pendientes />
                            </ProtectedRoute>
                        } />

                        <Route path="/pendientes-alumno" role="CREAR_SOLICITUD" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <PendientesTablets />
                            </ProtectedRoute>
                        } />

                        <Route path="/uniforme-talla/:q/:e/:f" role="CREAR_SOLICITUD" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <Uniforme />
                            </ProtectedRoute>
                        } />

                        <Route path="/multientrega-tallas/:q/:e/:f" role="CREAR_SOLICITUD" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <Multientrega />
                            </ProtectedRoute>
                        } />

                        <Route path="/multientrega-tablets" role="CREAR_SOLICITUD" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <MultientregaTablets />
                            </ProtectedRoute>
                        } />

                        {/* <Route path="/entrega-personal" role="CREAR_SOLICITUD" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <EntregaPersonal />
                            </ProtectedRoute>
                        } /> */}

                        <Route path="/multientrega-scanner/:q/:e/:f" role="CREAR_SOLICITUD" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <MultientregaScanner />
                            </ProtectedRoute>
                        } />

                        <Route path="/resumen/:q" role="CREAR_SOLICITUD" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <Resumen />
                            </ProtectedRoute>
                        } />

                        <Route path="/resumen-alumno/:q" role="CREAR_SOLICITUD" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <ResumenTabletas />
                            </ProtectedRoute>
                        } />

                        <Route path="/reporte-general" role="CREAR_SOLICITUD" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <ReporteGeneral />
                            </ProtectedRoute>
                        } />

                        <Route path="/imprenta-vales" role="CREAR_SOLICITUD" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <ImprentaVales />
                            </ProtectedRoute>
                        } />

                         <Route path="/imprenta-nominas" role="CREAR_SOLICITUD" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <ImprentaNominas />
                            </ProtectedRoute>
                        } />

                        <Route path="/archivos" role="CREAR_SOLICITUD" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <Archivo />
                            </ProtectedRoute>
                        } />

                        <Route path="/Carga-archivos" role="CREAR_SOLICITUD" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <CargaArchivos />
                            </ProtectedRoute>
                        } />

                        <Route path="/configuracion/usuarios" role="CREAR_SOLICITUD" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <ListaUsuarios />
                            </ProtectedRoute>
                        } />

                        <Route path="/configuracion/usuario/crear" role="CREAR_SOLICITUD" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <CreateUser />
                            </ProtectedRoute>
                        } />

                        <Route path="/configuracion/ciclo" role="CREAR_SOLICITUD" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <ListaCiclos />
                            </ProtectedRoute>
                        } />

                        <Route path="/configuracion/ciclo/crear" role="CREAR_SOLICITUD" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <CreateCiclo />
                            </ProtectedRoute>
                        } />

                        <Route path="/configuracion/tiendas" role="CREAR_SOLICITUD" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <ListaTiendas />
                            </ProtectedRoute>
                        } />

                        <Route path="/accesos/tienda/crear" role="CREAR_SOLICITUD" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <CreateTienda />
                            </ProtectedRoute>
                        } />

                        <Route path="/cambios/:q" role="CREAR_SOLICITUD" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <CambioScanner />
                            </ProtectedRoute>
                        } />

                        <Route path="/Scanner" role="CREAR_SOLICITUD" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <Scanner />
                            </ProtectedRoute>
                        } />

                        {/*reportes*/}

                        <Route path="/dashboard" role="CREAR_SOLICITUD" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <Dashboard />
                            </ProtectedRoute>
                        } />
                        <Route path="/reporte/corte-tienda" role="CREAR_SOLICITUD" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <ReporteCorteTienda />
                            </ProtectedRoute>
                        } />
                        <Route path="/reporte/corte-administrador" role="CREAR_SOLICITUD" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <ReporteCorteAdministrador />
                            </ProtectedRoute>
                        } />

                        <Route path="/reporte/ReporteNivelMunicipioPdf" role="CREAR_SOLICITUD" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <ReporteNivelMunicipioPdf />
                            </ProtectedRoute>
                        } />


                        <Route path="/reporte/maquila" role="CREAR_SOLICITUD" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <ReporteMaquila />
                            </ProtectedRoute>
                        } />

                        <Route path="/reporte/existencia-inventario" role="CREAR_SOLICITUD" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <ReporteExistenciaInventario />
                            </ProtectedRoute>
                        } />

                        <Route path="/evidencias" role="CREAR_SOLICITUD" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <ReporteEvidencias />
                            </ProtectedRoute>
                        } />

                        {/*validación*/}

                        <Route path="/validacion" role="CREAR_SOLICITUD" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <FiltroValidacion />
                            </ProtectedRoute>
                        } />



                        {/*<Route path="/dashboard" role="DASHBOARD" element={
                        <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                            <Dashboard />
                        </ProtectedRoute>
                    } />*/}
                        <Route path="/nueva-solicitud" role="CREAR_SOLICITUD" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <Demand />
                            </ProtectedRoute>
                        } />
                        <Route path="/lista-solicitudes" role="LISTA_SOLICITUDES" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <DemandList />
                            </ProtectedRoute>
                        } />
                        <Route path="/lista-solicitudes-asignacion" role="ASIGNAR_SOLICITUD" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <DemandListAssignment />
                            </ProtectedRoute>
                        } />
                        <Route path="/lista-solicitudes-validacion" role="VALIDAR_SOLICITUD" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <DemandListValidation />
                            </ProtectedRoute>
                        } />
                        <Route path="/validacion" role="VALIDAR_SOLICITUD" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <ValidationDocuments />
                            </ProtectedRoute>
                        } />
                        <Route path="/perfil" role="PERFIL_DE_USUARIO" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <Profile />
                            </ProtectedRoute>
                        } />

                        <Route path="/administrar-usuarios" role="PERFIL_DE_USUARIO" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <Users />
                            </ProtectedRoute>
                        } />
                        <Route path="/validacion-documentos/:solicitudid/:adjuntoid" role="PERFIL_DE_USUARIO" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <DocumentValidationProcess />
                            </ProtectedRoute>
                        } />

                        <Route path="/lista-solicitudes-registro" role="PERFIL_DE_USUARIO" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <DemandListRegistry />
                            </ProtectedRoute>
                        } />

                        <Route path="/lista-reasignacion-solicitudes" role="PERFIL_DE_USUARIO" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <DemandListReassignment />
                            </ProtectedRoute>
                        } />

                        <Route path="/historial-asignaciones" role="PERFIL_DE_USUARIO" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <RecordAssignment />
                            </ProtectedRoute>
                        } />

                        <Route path="/historial-validaciones" role="PERFIL_DE_USUARIO" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <RecordValidation />
                            </ProtectedRoute>
                        } />

                        <Route path="/solicitud/:q" role="PERFIL_DE_USUARIO" element={
                            <ProtectedRoute redirectPath="/login" isAllowed={!!auth}>
                                <SolicitudCedula />
                            </ProtectedRoute>
                        } />

                        {/*Almacen*/}
                        <Route path='/almacen/registro' role="CREAR_SOLICITUD" element={
                            <ProtectedRoute redirectedPath="/login" isAllowed={!!auth}>
                                <AltaTablets />
                            </ProtectedRoute>
                        } />

                        <Route path='/almacen/salida' role="CREAR_SOLICITUD" element={
                            <ProtectedRoute redirectedPath="/login" isAllowed={!!auth}>
                                <SalidaTablets />
                            </ProtectedRoute>
                        } />

                        <Route path='/director/DashboardDirector' role="CREAR_SOLICITUD" element={
                            <ProtectedRoute redirectedPath="/login" isAllowed={!!auth}>
                                <DashboardDirector />
                            </ProtectedRoute>
                        } />

                        <Route path='/maquila' role="CREAR_SOLICITUD" element={
                            <ProtectedRoute redirectedPath="/login" isAllowed={!!auth}>
                                <DashboardMaquila />
                            </ProtectedRoute>
                        } />






                        {/*<Route  path="/dashboard" role="DASHBOARD" element={<Dashboard/>} />
                    <Route  path="/nueva-solicitud" role="CREAR_SOLICITUD" element={<Demand/>} />
                    <Route  path="/lista-solicitudes" role="LISTA_SOLICITUDES" element={<DemandList/>} />
                    <Route  path="/digitalizacion" role="LISTA_SOLICITUDES" element={<Digitization/>} />
                    
                    <Route  path="/lista-solicitudes-asignacion" role="ASIGNAR_SOLICITUD" element={<DemandListAssignment/>} />
                    <Route  path="/lista-solicitudes-validacion" role="VALIDAR_SOLICITUD" element={<DemandListValidation/>} />
                    <Route  path="/validacion" role="VALIDAR_SOLICITUD" element={<ValidationDocuments/>} />
                    <Route  path="/cerrar-solicitud" role="VALIDAR_SOLICITUD" element={<CloseDemand/>} />
                    <Route  path="/profile" role="PERFIL_DE_USUARIO" element={<Profile/>} />*/}

                        {/* Rutas privadas fin */}


                        <Route path="/error044" element={<Error044 />} />
                        <Route path="/ReCaptcha" element={<ReCaptcha />} />
                        <Route path="/Example" element={<Example />} />

                        <Route path="/formlayout" element={<FormLayoutDemo />} />
                        <Route path="/input" element={<InputDemo />} />
                        <Route path="/floatlabel" element={<FloatLabelDemo />} />
                        <Route path="/invalidstate" element={<InvalidStateDemo />} />
                        <Route path="/button" element={<ButtonDemo />} />
                        <Route path="/table" element={<TableDemo />} />
                        <Route path="/list" element={<ListDemo />} />
                        <Route path="/tree" element={<TreeDemo />} />
                        <Route path="/panel" element={<PanelDemo />} />
                        <Route path="/overlay" element={<OverlayDemo />} />
                        <Route path="/menu" element={<MenuDemo />} />
                        <Route path="/messages" element={<MessagesDemo />} />
                        <Route path="/blocks" element={<BlocksDemo />} />
                        <Route path="/icons" element={<IconsDemo />} />
                        <Route path="/file" element={<FileDemo />} />
                        <Route path="/chart" element={<ChartDemo colorMode={layoutColorMode} location={location} />} />
                        <Route path="/misc" element={<MiscDemo />} />
                        <Route path="/timeline" element={<TimelineDemo />} />
                        <Route path="/crud" element={<Crud />} />
                        <Route path="/empty" element={<EmptyPage />} />
                        <Route path="/examplepage" element={<ExamplePage />} />
                        <Route path="/documentation" element={<Documentation />} />
                    </Routes>
                </div>

                <AppFooter layoutColorMode={layoutColorMode} />
            </div>

            <AppConfig
                rippleEffect={ripple}
                onRippleEffect={onRipple}
                inputStyle={inputStyle}
                onInputStyleChange={onInputStyleChange}
                layoutMode={layoutMode}
                onLayoutModeChange={onLayoutModeChange}
                layoutColorMode={layoutColorMode}
                onColorModeChange={onColorModeChange}
            />

            <CSSTransition classNames="layout-mask" timeout={{ enter: 200, exit: 200 }} in={mobileMenuActive} unmountOnExit>
                <div className="layout-mask p-component-overlay"></div>
            </CSSTransition>

        </div>
    );

}

export default App;
